export class SaveUploadModel {
    batchId: number;
    entityId: number;
    entityTypeId: number;
    makeZeroPricedUnavailable: boolean;
}
